import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import goodsSubApi from '../../api/goodsSubApi';
import { MESSAGE } from '../../constants';


export const useGoodsSub = () => {

    const location = useLocation();
    const objSearch = useMemo(() => {
        const search = new URLSearchParams(location.search);
        const obj = {
            txtSearch: search.get("search") || '',
        };
        return obj;
    }, [location.search]);
    const { id: goodsID } = useParams();
    const [termSearch, setTermSearch] = useState({ txtSearch: objSearch?.txtSearch || '' });
    const [goodsSubList, setGoodsSubList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        title: '',
        type: '',
        contents: []
    });

    const navigate = useNavigate();
    useEffect(() => {
        navigate(`?search=${termSearch.txtSearch}`, { replace: true });
    }, [navigate, termSearch])


    useEffect(() => {

        async function searchGoods() {
            try {
                setIsLoading(true);

                /**Call Api */
                const params = {
                    goodsID: goodsID,
                    txtSearch: termSearch?.txtSearch || '',
                }
                const dtResponse = await goodsSubApi.search(params);
                const dtGoodsSub = dtResponse?.data['dtGoodsSub'];
                //商品サブ：自分入力
                if (dtGoodsSub.length > 0) {
                    const goodsSeftInput = { ...dtGoodsSub[0], GoodsSubID: 0, GoodsSubName: '自分入力', GoodsSubKana: 'ジブンニュウリョク' }
                    setGoodsSubList([goodsSeftInput, ...dtGoodsSub]);
                } else {
                    setGoodsSubList(dtGoodsSub);
                }
                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);
                const errMsg = {
                    type: MESSAGE.ERROR,
                    contents: [err]
                }
                setMessage(errMsg);
            }
        }

        searchGoods();
    }, [termSearch, goodsID])

    return { goodsSubList, termSearch, setTermSearch, isLoading, message, setMessage };
}